import { render, staticRenderFns } from "./PresentationPage.vue?vue&type=template&id=d8252452&scoped=true"
import script from "./PresentationPage.vue?vue&type=script&lang=js"
export * from "./PresentationPage.vue?vue&type=script&lang=js"
import style0 from "./PresentationPage.vue?vue&type=style&index=0&id=d8252452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8252452",
  null
  
)

export default component.exports